<template>
  <div>
    <div class="tw-text-gray-800">{{ event.type }}</div>
    <div class="tw-mt-0.5 tw-text-xs tw-text-gray-500">
      {{ event.label }}
    </div>
    <div class="tw-mt-1 tw-flex tw-items-center tw-text-gray-500 tw-space-x-3 tw-text-xs" v-if="event.businessLocationName">
      <div class="tw-flex tw-items-center tw-overflow-hidden">
        <location-icon class="tw-flex-shrink-0 tw-h-2.5 tw-w-2.5 tw-mr-1" />
        <div class="tw-truncate">
          {{ event.businessLocationName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LocationIcon } from "@/assets/svgs";

export default {
  components: {
    LocationIcon,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
};
</script>
